import {
    SIGNUP_FETCH,
    LOGIN_FETCH,
    SIGNUP_ERROR,
    LOGIN_ERROR,
    LOGIN_FORGOT_SUCCESS,
    LOGIN_FORGOT_FETCH,
    PACE_RESET
} from '../actions/auth'

export function authReducer(state = {
    isFetch: false
}, action){    
    switch(action.type){ 
        case PACE_RESET: 
            return Object.assign({}, state, {
                isFetch: false
            })
        case LOGIN_FORGOT_SUCCESS: {
            return Object.assign({}, state, {
                 isFetch: false
            })        
        }
        case LOGIN_FORGOT_FETCH: {
            return Object.assign({}, state, {
                isFetch: true
            })        
        }
        case SIGNUP_FETCH:       
        case LOGIN_FETCH:
            return Object.assign({}, state, {
                isFetch: true
            })        
        case SIGNUP_ERROR:
        case LOGIN_ERROR:
            return Object.assign({}, state, {
                isFetch: false
            })        
        default: 
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/authReducer.js